export default "__VITE_ASSET__CUSex5c5__"